import { mallApi, mallEntranceApi } from '../request'
import { apiPath } from '../api'

export const newReqGood = {
  getNewGoodReqList: data => mallApi.post(apiPath.getNewGoodReqList, data),
  getNewGoodSuggest: data => mallApi.post(apiPath.getNewGoodSuggest, data),
  getOssKey: data => mallEntranceApi.post(apiPath.getOssKey, data),
  getNewGoodReqSaleClass: data =>
    mallApi.post(apiPath.getNewGoodReqSaleClass, data),
  createNewGoodReq: data => mallApi.post(apiPath.createNewGoodReq, data),
  getNewGoodReqDetail: data => mallApi.post(apiPath.getNewGoodReqDetail, data)
}
